/* eslint-disable no-underscore-dangle */
// ■コンポーネント説明
// 事例詳細表示用コンポーネント

import React from 'react';
import SEO from '@/components/seo';
import ServiceRelation from '@/components/Service/ServiceRelation';
import CDNReplace from '@/components/CDNReplace';
import UILabel from '@/components/UI/UILabel';
import UIBreadcrumb from '@/components/UI/UIBreadcrumb';
import ContactBox from '@/components/Contact/ContactBox';

import * as pageHeaderDetail from '@/styles/object/page-header-detail.module.scss';

export interface CaseDetailProps {
  data: GatsbyTypes.CasesPageQuery;
}

const CasesDetail: React.FC<CaseDetailProps> = (props) => {
  const { data } = props;
  const contactData: readonly Pick<
    MicrocmsServiceBodyContact,
    'button' | 'title' | 'id' | 'tayori'
  >[] = [];

  if (data.microcmsCase === null) {
    if (typeof window !== `undefined`) {
      window.location.href = `/404`;
    }
    return null;
  }

  if (data.microcmsCase.contact !== null) {
    contactData.push(data.microcmsCase.contact);
  }

  return (
    <>
      <SEO
        title={`${data.microcmsCase.title} | 事例`}
        description={data.microcmsCase.description}
        keyword={data.microcmsCase.keyword}
        ogpImage={
          data.microcmsCase.thumbnail ? data.microcmsCase.thumbnail.url : ``
        }
      />
      <div className="page-wrap --detail --common">
        <div className="page-wrap__wave" />
        <div className="page-wrap__bg" />
        <div className="page-contents-box">
          <header
            className={`${pageHeaderDetail.page_header_detail} ${pageHeaderDetail.__rows}`}
          >
            <div className={pageHeaderDetail.page_header_detail__inner}>
              <p className={pageHeaderDetail.page_header_detail__title_head}>
                {data.microcmsCase.tag.map(({ id, tag }) => (
                  <UILabel key={id} text={tag} />
                ))}
              </p>
              <h1 className={pageHeaderDetail.page_header_detail__title}>
                {data.microcmsCase.title}
              </h1>
              <p className={pageHeaderDetail.page_header_detail__sub_text}>
                {data.microcmsCase.customer}
              </p>
            </div>
            <figure className={pageHeaderDetail.page_header_detail__fig}>
              <img
                loading="lazy"
                src={`${CDNReplace(
                  data.microcmsCase.thumbnail
                    ? data.microcmsCase.thumbnail.url
                    : data.microcmsEnv.commonNoImage.url,
                )}?fit=crop&w=320&h=180&auto=format&q=75`}
                alt=""
              />
            </figure>
          </header>

          <div className="page-contents-area-03">
            <div className="editor">
              {data.microcmsCase.body &&
                data.microcmsCase.body.map((body) => {
                  let output = ``;
                  if (body.rich) {
                    output = body.rich;
                  }
                  if (body.plain) {
                    output = body.plain;
                  }
                  if (body.asset) {
                    const arr = body.asset.assetBody;
                    arr.forEach((elem) => {
                      if (elem.rich) {
                        output += elem.rich;
                      }
                    });
                  }
                  return (
                    <section
                      key={output}
                      className="section"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: CDNReplace(output) }}
                    />
                  );
                })}
            </div>
          </div>
        </div>
        <ContactBox service={contactData} />
        <ServiceRelation currentTag={data.microcmsCase.tag} />
        <UIBreadcrumb
          UpperItem={[
            [`Works`, `/works`],
            [`Case`, `/cases`],
          ]}
          CurrentItem={data.microcmsCase.title}
        />
      </div>
    </>
  );
};

export default CasesDetail;
